module.exports = __webpack_public_path__ + "static/media/Household.984ac87c.jpg";